module.exports = __webpack_public_path__ + "img/geod_4.19111c81.jpg";